import React, { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './HistoryOrder.module.scss';
import CardAboutMe from '../../components/card-about-me';
import { Row, Divider, Spin, Tabs, Pagination } from 'antd';
import styled from 'styled-components';
import { SVGS } from '~/assets/assetsPath';
import ItemOrder from '~/components/ItemOrder';
import orderAPI from '~/api/OrderAPI';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { useNavigate } from 'react-router';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';

const { TabPane } = Tabs;
const cx = classNames.bind(styles);

const TabsContainer = styled.div`
    .ant-tabs-tab {
        font-size: 16px;
        font-weight: 600;
        color: rgba(137, 137, 137, 1);
    }
    .ant-tabs-tab.ant-tabs-tab-active {
        border-bottom: 3px solid #311d4f !important;
        z-index: 2;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #311d4f;
    }
    .ant-tabs > .ant-tabs-nav,
    .ant-tabs > div > .ant-tabs-nav {
        margin: 0px 30px;
        @media screen and (max-width: 480px) {
            margin: 0px 10px;
        }
    }
    .ant-tabs-bottom > .ant-tabs-nav:before,
    .ant-tabs-bottom > div > .ant-tabs-nav:before,
    .ant-tabs-top > .ant-tabs-nav:before,
    .ant-tabs-top > div > .ant-tabs-nav:before {
        border-bottom: 3px solid #e2e2e2;
    }
`;
const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const HistoryOrder = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const activeKeyHistoryOrder = localStorage.getItem('activeKeyHistoryOrder');

    const [activeKey, setActiveKey] = useState(activeKeyHistoryOrder || '');

    const [listHistoryOrder, setListHistoryOrder] = useState([]);

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const onChangeTabs = (key) => {
        localStorage.setItem('activeKeyHistoryOrder', key);
        setActiveKey(key);
        setPagination({
            page: 1,
            limit: 10,
            total_item: 0,
            total_page: 0,
        });
        handleGetListHistoryOrder(1, key);
    };

    const handleGetListHistoryOrder = async (page, status) => {
        try {
            setIsLoading(true);
            let orders = [];
            let final = [];
            const params = {
                fields: '["$all", {"branch": ["$all"]}, {"order_items":["$all", {"product": ["$all", {"category": ["$all"]}]}]}]',
                order: '[["created_at", "DESC"]]',
                filter: status ? `{"activity": "${status}"}` : null,
                limit: pagination.limit,
                page: page,
            };
            const res = await orderAPI.getListOrderAPI(params);

            if (res.code === 200) {
                orders = res.results.objects.rows;
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (orders?.length) {
                final = [...new Map(orders.map((item) => [item['id'], item])).values()];
            }
            setListHistoryOrder([...final]);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };
    const handleChangePagination = (page) => {
        setPagination({ ...pagination, page: page });
        handleGetListHistoryOrder(page, activeKey);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        handleGetListHistoryOrder(pagination.page, activeKey);
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangLichSuDonHang');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 3, children: null }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Purchased order
                        </p>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <div className={cx('right_container')}>
                        <TabsContainer>
                            <Tabs defaultActiveKey={activeKey} onChange={onChangeTabs}>
                                <TabPane tab="All" key="">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>

                                <TabPane tab="Waiting for confirmation" key="WAITING">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>

                                <TabPane tab="Waiting for pickup" key="CONFIRMED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>

                                <TabPane tab="Delivering" key="PROCESSING">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>

                                <TabPane tab="Received" key="COMPLETED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>

                                <TabPane tab="Cancelled" key="CANCELED">
                                    {isLoading ? (
                                        <Row justify="center" className={cx('spin')}>
                                            <Spin />
                                        </Row>
                                    ) : (
                                        <Content
                                            listHistoryOrder={listHistoryOrder}
                                            handleGetListHistoryOrder={handleGetListHistoryOrder}
                                            page={pagination?.page}
                                            activeKey={activeKey}
                                        />
                                    )}
                                </TabPane>
                            </Tabs>
                            {listHistoryOrder?.length ? (
                                <Row justify="center">
                                    <PaginationCustom>
                                        <Pagination
                                            defaultCurrent={1}
                                            current={pagination?.page}
                                            total={pagination?.total_item}
                                            pageSize={pagination?.limit}
                                            onChange={handleChangePagination}
                                        />
                                    </PaginationCustom>
                                </Row>
                            ) : null}
                        </TabsContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Content = ({ listHistoryOrder, handleGetListHistoryOrder, page, activeKey }) => {
    return (
        <div>
            {listHistoryOrder?.length ? (
                <>
                    <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                    {listHistoryOrder?.map((item, index) => {
                        return (
                            <ItemOrder
                                item={item}
                                key={index}
                                handleGetListHistoryOrder={handleGetListHistoryOrder}
                                page={page}
                                activeKey={activeKey}
                            />
                        );
                    })}
                </>
            ) : (
                <>
                    <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} />
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span>No orders</span>
                    </div>
                </>
            )}
        </div>
    );
};

export default HistoryOrder;
